// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__132zz","container":"styles_container__10YLs","title":"styles_title__tgTDa","wrapper":"styles_wrapper__3jzuC","answer":"styles_answer__Poy0c"};